export interface ProcessedOrderDetails {
  loading: boolean;
  error: any;
  isFullyCancelled: boolean;
  cancelledAt: string | null;

  deliveries: {
    subOrderId: string;
    index: number;
    state: string;
    deliveryDate: string | null;
    timeWindow: string | null;
    items: OrderLine[];
  }[];

  unavailableItems: OrderLine[];

  summary?: {
    subtotal: number;
    vat: number;
    deliveryFee: number;
    total: number;
  };

  raw: Order | null;
}

export interface GetOrderDetailsVariables {
  code: string;
}

export interface GetOrderDetailsResponse {
  orderByCode: Order | null;
}

interface Order {
  id: string;
  code: string;
  state: string;
  active: boolean;

  customer?: {
    firstName: string;
    lastName: string;
    phoneNumber: string;
  } | null;

  timeWindow?: TimeWindow | null;
  deliveryTime?: string | null;

  subTotal: number;
  subTotalWithTax: number;
  total: number;
  totalWithTax: number;

  shipping: number;
  shippingWithTax: number;

  shippingAddress?: OrderAddress | null;

  subOrders: SubOrder[];

  updatedAt?: string; // exists only on some orders
}

export interface TimeWindow {
  description: string;
}

export interface OrderAddress {
  fullName: string;
  company?: string | null;
  streetLine1: string;
  streetLine2?: string | null;
  city: string;
  province?: string | null;
  postalCode?: string | null;
  country: string;
  phoneNumber?: string | null;
  __typename: string;
}

export interface SubOrder {
  id: string;
  state: string;
  lines: OrderLine[];
  deliveryTime?: string | null;
}

export interface OrderLine {
  id: string;
  productVariant: ProductVariant;
  featuredAsset?: Asset | null;
  linePriceWithTax: number;
  deliveryDate?: string | null;
  cancelledQuantity: number;
  quantity?: number;
}

export interface ProductVariant {
  id: string;
  name: string;
  featuredAsset?: Asset | null;
}

export interface Asset {
  source: string;
  preview: string;
}

export enum OrderState {
  OPEN = "open",
  SHIPPING = "shipping",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
}
